import React from 'react';
import {PageLoader} from 'src/components';
import Box from 'react-raster';
import styled from "styled-components";

const StyledLoadingView = styled.div`
display: flex;
width: 100vw;
height: 50vh;
align-items: center;
justify-content: center;
`

export const LoadingView = () => (
 <StyledLoadingView>
    <PageLoader />
  </StyledLoadingView>
)